import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import type { ContentRefKind } from '@gitbook/app-content-refs';
import { Description, FieldGroup, Label, TextInput } from '@gitbook/spine-react';

import { ContentReferenceInput } from '../..';

export function ContentRefField(props: {
    name: string;
    required: boolean;
    accept?: ContentRefKind[];
    placeholder?: string;
}) {
    const { control } = useFormContext();
    const { field, fieldState } = useController({
        name: props.name,
        control,
        rules: props.required
            ? {
                  required: 'Required',
              }
            : undefined,
    });

    return (
        <FieldGroup>
            <Label>Link</Label>
            <Description>Enter a URL or link to some content.</Description>
            <React.Suspense fallback={<TextInput disabled value="Loading..." />}>
                <ContentReferenceInput
                    size="medium"
                    placeholder={props.placeholder ?? 'Search for content or type a URL...'}
                    value={field.value ?? undefined}
                    onChangeValue={field.onChange}
                    accept={props.accept}
                    feedback={
                        fieldState.error?.message
                            ? { type: 'danger', message: fieldState.error.message }
                            : undefined
                    }
                />
            </React.Suspense>
        </FieldGroup>
    );
}
